/**
 * 模板管理
 */
import { logDialog } from './_dialogs'
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import { TemplateTypeName } from '@/config/enums'
import dayjs from 'dayjs'

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/cabinet/admin/mkt/AdminMktProductTemplateQueryController/page'
      },
      add: {
        label: '新增模板',
        link: {
          title: '新增模板',
          name: 'tuda.cabinet.template.add',
          path: '/cabinet/template/add',
          query: {
            type: 'add'
          }
        }
      },
      edit: {
        label: '编辑模板',
        link: {
          title: '编辑模板',
          name: 'tuda.cabinet.template.add',
          path: '/cabinet/template/add',
          query: {
            type: 'edit',
            templateCode: '${data.row.templateCode}'
          }
        }
      },
      log: {
        label: '日志',
        dialog: logDialog()
      }
    },
    searchOn: [UI_PAGE_EVENTS.ACTIVATED],
    search: {
      items: [
        { type: 'input', prop: 'templateCode', label: '模板ID', span: 6 },
        { type: 'input', prop: 'templateName', label: '模板名称', span: 6 }
      ]
    },
    toolbar: {
      noExport: true,
      items: [{ action: 'add' }]
    },
    table: {
      operation: {
        width: 150,
        items: [{ action: 'edit' }, { action: 'log' }]
      },
      columns: [
        { label: '模板ID', prop: 'templateCode', minWidth: 180 },
        { label: '模板名称', prop: 'templateName', minWidth: 180 },
        {
          label: '模板类型',
          minWidth: 180,
          formatter: (row: any) => {
            return (TemplateTypeName as any)[row.templateType] || row.templateType
          }
        },
        { label: '创建人', prop: 'creator', minWidth: 150 },
        {
          label: '创建时间',
          minWidth: 150,
          formatter: (row: any) => {
            return row.gmtCreate ? dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : '--'
          }
        },
        { label: '更新人', prop: 'modifier', minWidth: 150 },
        {
          label: '更新时间',
          minWidth: 150,
          formatter: (row: any) => {
            return row.gmtModified ? dayjs(row.gmtModified).format('YYYY-MM-DD HH:mm:ss') : '--'
          }
        }
      ]
    }
  }
}
